// i18n area 'cluster' — locale sq-AL (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.sq-AL.meta.json.
import type { enUS } from './cluster'

export const sqAL: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Aksese garancie',
      subtitle: 'Dera e shërbimit e nyjes: aksesi vetëm për lexim me fjalëkalim të përkohshëm dhe llogaria e emergjencës me fjalëkalimin e kasafortës',
      readOnlyTitle: 'Akses vetëm për lexim (trantor)',
      stateNone: 'i mbyllur',
      stateGranted: 'i hapur',
      stateGrantedPending: 'i dhënë — po aplikohet në nyje',
      grantedBy: 'Dhënë nga',
      grantedAt: 'Dhënë më',
      expiresAt: 'Skadon më',
      reason: 'Arsyeja',
      endedAt: 'I mbyllur',
      endedReason: {
        revoked: 'i revokuar',
        expired: 'i skaduar (TTL)',
        reboot: 'rinisje e nyjes',
        failed: 'i paaplikuar (detyra dështoi)'
      },
      grant: 'Jep akses vetëm për lexim…',
      grantTitle: 'Jep akses vetëm për lexim',
      grantSubmit: 'Jep',
      grantError: 'Dhënia u refuzua',
      grantConfirm: 'TVirt gjeneron një fjalëkalim të përkohshëm për përdoruesin e sistemit «trantor» (vetëm lexim: journal dhe diagnostikë, pa sudo) dhe e vendos në nyje me një detyrë. Fjalëkalimi shfaqet VETËM një herë, në konfirmim; pushon në skadim, në revokim ose në rinisjen e ardhshme të nyjes.',
      reasonLabel: 'Arsyeja',
      reasonHint: 'Pse e hap derën: mbetet në dhënie, në auditim dhe në ditar',
      ttlLabel: 'Kohëzgjatja',
      ttlHours: '{n} orë',
      revoke: 'Revoko aksesin vetëm për lexim…',
      revokeTitle: 'Revoko aksesin vetëm për lexim',
      revokeSubmit: 'Revoko',
      revokeError: 'Revokimi u refuzua',
      revokeConfirm: 'Dhënia përfundon menjëherë dhe një detyrë e bllokon sërish përdoruesin «trantor» në nyje: fjalëkalimi i përkohshëm pushon së vlejturi.',
      passwordTitle: 'Fjalëkalim vetëm për lexim',
      passwordOnce: 'Ky fjalëkalim shfaqet VETËM një herë: kopjoje tani. Nuk ruhet askund dhe nuk mund të lexohet sërish — nëse e humb, jepe sërish.',
      passwordUser: 'Përdoruesi',
      passwordLabel: 'Fjalëkalimi',
      passwordHint: 'I vlefshëm deri më {until}, ose deri në rinisjen e ardhshme të nyjes; i përdorshëm kur detyra e dhënies të ketë përfunduar. Aksesi: ssh trantor@<adresa e nyjes>.',
      emergencyTitle: 'Aksesi i fundit i emergjencës (trantor-emergency)',
      lastLogin: '{time} përmes {via} nga {from}',
      lastLoginNone: 'asnjë i vërejtur',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konsolë',
        sudo: 'sudo',
        unknown: 'i panjohur'
      },
      emergencyHint: 'Llogaria e emergjencës «trantor-emergency» (sudo i plotë) është gjithmonë e aktivizuar me fjalëkalimin e gjeneruar në instalimin e nyjes dhe të ruajtur në kasafortë: TVirt nuk e njeh, nuk e rrotullon dhe nuk e rikuperon. Çdo hyrje raportohet këtu dhe në ditarin e ngjarjeve.'
    },
    nodeFirewall: {
      tab: 'Firewall',
      title: 'Firewall-i i nyjeve',
      subtitle: 'Postura e ruleset-it nftables që çdo nyjë ia aplikon vetes — i vetmi firewall i një nyje (firewalld është i çaktivizuar)',
      modeLabel: 'Postura',
      mode: {
        disabled: 'I çaktivizuar — asnjë ruleset mbi nyjet',
        permissive: 'Lejues — numëron dhe regjistron, nuk hedh poshtë asgjë',
        enforced: 'I zbatuar — hyn vetëm regjistri i derivuar'
      },
      hint: {
        disabled: 'Siç është sot: nyjet nuk mbartin asnjë ruleset. Kalo në lejues për të LEXUAR çfarë do të hidhej poshtë para se të hidhet poshtë.',
        permissive: 'Çdo nyjë e aplikon ruleset-in e vet të derivuar me policy accept: ajo që mënyra e zbatuar do ta hidhte poshtë numërohet dhe regjistrohet (prefiks journal-i «tvirt-node would-drop:»). Asgjë nuk bllokohet.',
        enforced: 'Çdo nyjë e aplikon ruleset-in e vet të derivuar me policy drop: ssh dhe API nga kudo, store / live migration / overlay / Ceph vetëm nga anëtarët, listener-ët e shërbimeve të rrjetit nga rrjeti që u shërbehet. Çdo ndryshim është një apply me konfirmim — një nyjë që nuk arrin të konfirmojë kthehet mbrapsht vetë.'
      },
      confirmTitle: 'Të zbatohet firewall-i i nyjeve?',
      confirmBody: 'Çdo nyjë e aplikon ruleset-in me konfirmim: sondon backend-in, store-in dhe ssh-në përmes rregullave të reja brenda afatit dhe konfirmon — përndryshe kthehet vetë te ruleset-i i mëparshëm. Lexo më parë numëruesit e mënyrës lejuese mbi nyjet.',
      confirmSubmit: 'Zbato',
      confirmCancel: 'Anulo',
      lensTitle: 'Firewall-i i nyjes',
      loadError: 'Nuk mund të ngarkohej lentja e firewall-it të nyjes',
      noReport: 'Asnjë raport firewall-i nga kjo nyjë, ende — worker-i raporton në kalimin e ardhshëm',
      firewalldActive: 'Në këtë nyjë xhiron firewalld: firewall-i i nyjes refuzon të aplikohet pranë tij (masko firewalld)',
      conditionUnconfirmed: 'Asnjë ruleset i konfirmuar, ende — nyja është e hapur',
      conditionRolledBack: 'Apply-i i fundit u kthye mbrapsht — e njëjta gjeneratë nuk riprovohet derisa regjistri të ndryshojë ose postura të ndryshohet përsëri',
      lastError: 'Gabimi i fundit',
      posture: 'Postura',
      observedAt: 'Vëzhguar',
      desiredGeneration: 'Gjenerata e dëshiruar',
      componentTitle: 'Komponenti i nyjes',
      componentSubtitle: 'tvirt-node-firewall — aplikon në boot ruleset-in e konfirmuar, kthen mbrapsht vetë një të pakonfirmuar',
      componentAbsent: 'Komponenti nuk ka raportuar ende',
      phase: 'Faza',
      phases: {
        none: 'Kurrë i aplikuar',
        applied: 'I aplikuar — në pritje të konfirmimit',
        confirmed: 'I konfirmuar',
        rolledBack: 'I kthyer mbrapsht'
      },
      generation: 'Gjenerata',
      appliedAt: 'Aplikuar më',
      confirmedAt: 'Konfirmuar më',
      deadline: 'Afati i rollback-ut',
      lastRollback: 'Rollback-u i fundit',
      registryTitle: 'Regjistri i derivuar',
      registrySubtitle: 'Portat që hap kjo nyjë, sipas klasës dhe origjinës — të derivuara nga klasteri, kurrë të ndryshuara me dorë',
      registryEmpty: 'Asgjë e derivuar — postura e çaktivizuar pa ruleset të konfirmuar, ose ende asnjë raport',
      colClass: 'Klasa',
      colPort: 'Porta',
      colSource: 'Burimi',
      colOrigin: 'Origjina',
      classes: {
        public: 'Publike',
        internode: 'Ndër-nyje',
        tenant: 'Tenant'
      },
      sourceMembers: 'vetëm anëtarët',
      sourceAnywhere: 'kudo',
      sourceBridge: 'mbi {iface}'
    },
    derivationDerived: 'i derivuar',
    derivationDiverged: 'i shmangur',
    derivationDerivedTip: 'Dokumenti i rrjetit është I DERIVUAR nga fabric {fabric} dhe ende përputhet me render-in mbi hyrjet aktuale — klik për planin e derivimit.',
    derivationDivergedTip: 'Derivimi nga fabric {fabric} ndryshoi pas apply-it të fundit (fabric, kablimi, rolet ose referencat) — klik për diff-in në pritje.',
    derivationRetiring: {
      one: '{n} adresë po zbrazet',
      other: '{n} adresa po zbrazen'
    },
    standaloneHint: 'Kjo nyjë nuk ka klaster: nuk është instaluar ende. Klasterët krijohen OSE join-ohen në instalim — token-i i gjeneruar nga tabela Server e një anëtari i jepet installer-it (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Lejet e tua mbulojnë një scope, jo gjithë klasterin: inventari i flotës — nyje, cilësime dhe pajisje — është i dukshëm vetëm për ata që administrojnë klasterin.',
    phaseReady: 'Gati',
    phaseForming: 'Në formim',
    storeMembers: 'Anëtarët e store-it',
    watermark: 'Pragu i konvergjencës',
    configGeneration: 'Gjenerata e config-ut',
    converged: 'në linjë',
    behind: 'prapa — {m} / {n}',
    revision: 'Revizioni',
    rolesTitle: 'Rolet e rrjetit',
    rolesSubtitle: 'Adresa për anëtar të secilës klasë trafiku — lidhshmëria jeton në rrjetin host',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'trashëgon management-in',
    settingsTitle: 'Cilësimet',
    settingsSubtitle: 'Policy sigurie në nivel klasteri — e vlerësuar nga secila nyjë prej replikës së vet lokale',
    taskRetentionTitle: 'Mbajtja e task-eve',
    taskRetentionSubtitle: 'GC i unifikuar për të gjithë task-et — task-et e përfunduar përtej moshës ose tavanit mblidhen, kurrë ata në ekzekutim',
    taskRetentionMaxAge: 'Mosha maksimale (ditë)',
    taskRetentionMaxCount: 'Numri maksimal i task-eve',
    eventRetentionTitle: 'Ruajtja e eventeve',
    eventRetentionSubtitle: 'GC-ja e ditarit — një politikë e pavarur nga ajo e detyrave: detyra është radhë, eventi është kujtesë',
    eventRetentionMaxAge: 'Mosha maksimale (ditë)',
    eventRetentionMaxCount: 'Numri maksimal i eventeve',
    spaceThresholdsTitle: 'Pragjet e hapësirës',
    spaceThresholdsSubtitle: 'Kur një hapësirë ruajtjeje që mbushet hyn në ditar (dhe në njoftimet)',
    spaceLowPct: 'Paralajmërim nga (% e përdorur)',
    spaceCriticalPct: 'Kritik nga (% e përdorur)',
    spaceOrderError: 'Kritiku nuk mund të jetë nën paralajmërimin',
    spaceThresholdsHint: 'Konfigurohen vetëm hyrjet: daljen e nxjerr motori, 5 pikë nën çdo prag, që një hapësirë ruajtjeje mbi vijë të mos bëhet kurrë metronom',
    failoverReserveTitle: 'Rezerva e failover-it',
    failoverReserveSubtitle: 'Admission control N+1 — RAM e mbajtur e lirë që klasteri të mund ta rinisë ngarkesën e vet pas humbjes së nyjeve',
    failoverReserveTolerate: 'Sa nyje të humbura të tolerohen',
    failoverReserveOff: '0 — rezerva e fikur: asnjë nisje nuk refuzohet kurrë për kapacitet failover-i',
    failoverReserveOn: 'Një nisje që do ta cenonte rezervën refuzohet me një 412 që shpjegon numrat',
    networkShapingTitle: 'Drejtësia e brezit',
    networkShapingSubtitle: 'Tri peshat tipologjike të pemës së shaping për çdo uplink — veprojnë vetëm nën konkurrencë',
    networkShapingRest: 'Pesha e pjesës tjetër (plani i kontrollit, storage, replikat)',
    networkShapingOverlay: 'Pesha e rrjeteve overlay',
    networkShapingLiveMigration: 'Pesha e live migration',
    networkShapingHint: 'Pjesa e garantuar = pesha / shuma e të trijave (parazgjedhje 300 / 100 / 200, secila nga 1 deri 10000); në një lidhje të lirë çdo klasë mund të marrë gjithë brezin',
    debugModeTitle: 'Mënyra debug',
    debugModeSubtitle:
      'Gabime të detajuara në paralajmërimet gjenerike të GUI-t — për ta parë shkakun e vërtetë kur një veprim «i dështuar» në realitet ka pasur sukses',
    debugModeLabel: 'Mënyra debug e aktivizuar',
    debugModeOn: 'Paralajmërimet gjenerike të gabimit shtojnë në fund shkakun themelor — detaje të brendshme të dukshme për çdo operator',
    debugModeOffHint: 'E fikur — paralajmërimet gjenerike të gabimit mbeten gjenerike, pa detaje të brendshme',
    nodeDetailsAction: 'Detajet e nyjes',
    node: {
      docTitle: 'Nyja',
      notFound: 'Nyja nuk u gjet',
      tabOverview: 'Panorama',
      tabStats: 'Statistikat',
      tabNetwork: 'Rrjeti',
      tabSettings: 'Cilësimet lokale',
      identityTitle: 'Identiteti',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'Porta YSQL',
      revision: 'Revizioni i config-ut',
      versionsTitle: 'Versionet e vëzhguara',
      heartbeatSubtitle: 'Gjendja e fundit që nyja ka raportuar për veten',
      cpuTitle: 'CPU',
      cpuModelTitle: 'Modeli i CPU-së',
      memoryTitle: 'Memoria',
      hugePagesTitle: 'Faqet e mëdha',
      hugePagesPool: '{size}: {free} të lira nga {total}',
      hugePagesNone: 'Asnjë pool',
      hugePagesNoneHint: 'Nyja nuk ka faqe të mëdha të rezervuara: VM-të që kërkojnë të tilla nuk mund të nisen këtu. Pool-i deklarohet në nyjë, me parametrat hugepagesz dhe hugepages të kernel-it ose duke shkruar nr_hugepages.',
      usageTitle: 'Përdorimi aktual',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'i pavëzhguar — asnjë kampion i freskët',
      statsNoData: 'Asnjë e dhënë në interval — seritë e nyjes kampionohen nga vetë nyja dhe shërbehen lokalisht.',
      observedTitle: 'Gjendja e vëzhguar',
      observedSubtitle: 'Shërbimet dhe asetet lokale të nyjes, siç i sheh worker-i'
    },
    editRolesTitle: 'Modifiko rolet e rrjetit',
    memberNode: 'Nyja',
    memberIp: 'Adresa IP',
    addMember: 'Shto anëtar',
    lmInherit: 'Përdor adresat e management-it',
    roleIpHint: 'Shtimi dhe heqja e anëtarëve është e lirë; ndryshimi në vend i IP-së së një anëtari ekzistues refuzohet — fluksi i migrimit të IP-ve vjen në një round të mëvonshëm.',
    roleError: 'Rolet nuk mund të përditësoheshin',
    nodesTitle: 'Nyjet',
    addNodeTitle: 'Shto nyjë në klaster',
    addNode: 'Shto nyjë',
    addNodeError: 'Nyja nuk mund të para-regjistrohej',
    nodeName: 'Emri i nyjes',
    nodeNameHint: 'duhet të përputhet me emrin e zgjedhur në instalim',
    nodeIp: 'IP e management-it',
    colName: 'Emri',
    colPhase: 'Faza',
    colServices: 'Shërbimet',
    colWatermark: 'Watermark',
    colLastSeen: 'Kontakti i fundit',
    colUps: 'UPS',
    upsCordonChip: 'kordon UPS',
    upsCordonTip: 'Nyja e dënoi veten mbi faktet e UPS-it të saj ({time}): e heq kordonin vetë kur rrjeti është i qëndrueshëm dhe bateria e rimbushur',
    upsUnreachable: 'UPS i paarritshëm',
    upsOnBattery: 'Me bateri',
    upsOnLine: 'Me rrjet',
    upsLowBattery: 'bateri e ulët',
    upsNoEstimateChip: 'autonomia e pavlerësuar',
    upsNoEstimateTip: 'UPS-i nuk publikon vlerësim autonomie: nyja dënohet vetëm nga flamuri LB (bateri e ulët) i UPS-it — rregulloni battery.runtime.low / LB në vetë UPS-in',
    upsLaneTip: 'Rrugë fikjeje UPS që nga {since}: dënuar nga {by}',
    upsUnit: 'njësi',
    upsStatus: 'gjendja NUT',
    upsLoad: 'ngarkesa',
    upsOnBatterySince: 'me bateri që nga',
    upsOnLineSince: 'me rrjet që nga',
    upsError: 'gabim',
    upsObservedAt: 'vëzhguar',
    upsNone: 'asnjë njësi UPS nuk i shërben kësaj nyje',
    upsBy: {
      runtime: 'autonomi nën prag',
      lowBattery: 'flamuri LB i UPS-it',
    },
    upsLane: {
      evacuate: 'evakuim',
      local: 'fikje në vend',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'ndalimi i mysafirëve',
      stoppingServices: 'ndalimi i shërbimeve',
      poweredOff: 'i fikur',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'Njësi UPS dhe pragje: nyja dënohet me autonomi ≤ prag ose flamur LB (gjithmonë i respektuar), rifillim me histerezë',
    upsRuntimeThreshold: 'Pragu i autonomisë (s)',
    upsRuntimeThresholdHint: 'Me bateri, me autonomi të vlerësuar ≤ prag nyja fiket me radhë (parazgjedhja 300)',
    upsResumeStable: 'Rrjet i qëndrueshëm për (s)',
    upsResumeStableHint: 'Rifillim vetëm me rrjet të vazhdueshëm prej të paktën kaq sekondash (parazgjedhja 60)',
    upsResumeCharge: 'Ngarkesa minimale në rifillim (%)',
    upsResumeChargeHint: 'Dhe bateri e rimbushur të paktën në këtë përqindje (parazgjedhja 25)',
    upsPolicyNote: 'Flamuri LB (bateri e ulët) i UPS-it dënon gjithmonë dhe nuk çaktivizohet; nuk ekziston prag mbi kohën me bateri. Çdo njësi mund të mbishkruajë tre numrat.',
    upsUnitNew: 'njësi e re',
    upsUnitSelectors: '{n} përzgjedhës etiketash (vetëm CLI)',
    upsUnitName: 'Emri i njësisë',
    upsUnitMode: 'Mënyra',
    upsModeExternal: 'e jashtme (upsd i të tjerëve)',
    upsModeManaged: 'e menaxhuar (UPS i lidhur me një nyje)',
    upsUnitUpsname: 'Emri NUT (upsname)',
    upsUnitHost: 'Hosti upsd',
    upsUnitAttachedNode: 'Nyja e lidhur',
    upsUnitDriver: 'Drajveri NUT',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Pajisja e drajverit',
    upsUnitDeviceHint: 'rreshti port= i ups.conf: bosh = auto',
    upsUnitPort: 'Porta upsd',
    upsUnitServedNodes: 'Nyjet e shërbyera',
    upsUnitServedNodesHint: 'emra nyjesh të ndarë me presje (përzgjedhësit e etiketave kalojnë nga CLI)',
    upsUnitOverrideHint: 'bosh = parazgjedhja e grupimit',
    upsUnitAdd: 'Shto njësi',
    unreachableSince: 'E paarritshme — heartbeat-i i fundit {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Dataplane-i overlay nuk e ka realizuar ende konfigurimin overlay aktual',
    overlaysError: 'Kalimi i fundit i pajtimit overlay dështoi: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Në pritje të join-it',
      'joining': 'Duke u bashkuar',
      'member': 'Anëtar'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Shfaqet vetëm tani — kopjoje menjëherë, nuk do të jetë më i lexueshëm',
    copy: 'Kopjo',
    copied: 'U kopjua',
    close: 'Mbyll',
    revokeTitle: 'Revoko para-regjistrimin',
    revoke: 'Revoko',
    revokeError: 'Regjistrimi nuk mund të revokohej',
    promote: 'Promovo në store member',
    demote: 'Hiq rolin store-member',
    troubleshoot: 'Zgjidhja e problemeve',
    promoteTitle: 'Promovo në store member',
    demoteTitle: 'Hiq rolin store-member',
    promoteHint: 'Nyja hyn në kuorumin e master-ëve YugabyteDB. HA e vërtetë kërkon tre store member.',
    demoteHint: 'Nyja del nga kuorumi i master-ëve dhe i ndal shërbimet e veta store.',
    storeError: 'Ndryshimi i store-member-it u refuzua',
    attest: 'Atesto të fikur…',
    attestTitle: 'Atesto nyjën të fikur',
    attestSubmit: 'Atesto të fikur',
    attestConfirm: 'Po e deklaron këtë nyjë të fikur, me rrezikun tënd: atestimi i një nyje në të vërtetë të gjallë rrezikon VM në ekzekutim të dyfishtë. Task-et e saj dështohen dhe authority-t e VM-ve të saj bëhen të transferueshme.',
    attestError: 'Atestimi u refuzua',
    attestedChip: 'e atestuar e fikur',
    maintenanceChip: 'mirëmbajtje',
    guestToolsChip: 'TVirt Guest Tools (aset ISO lokal i nyjes)',
    maintenanceEnter: 'Aktivizo mirëmbajtjen',
    maintenanceExit: 'Çaktivizo mirëmbajtjen',
    maintenanceEnterTitle: 'Aktivizo mirëmbajtjen',
    maintenanceExitTitle: 'Çaktivizo mirëmbajtjen',
    maintenanceEnterSubmit: 'Aktivizo mirëmbajtjen',
    maintenanceExitSubmit: 'Çaktivizo mirëmbajtjen',
    maintenanceEnterConfirm: 'Nyja vihet në kordon dhe zbrazet: shërbimet e rrjetit dhe instancat App autoritetin e të cilave e mban, transferohen (instancat në të ftohtë: ndalen dhe korren këtu, rikrijohen në nyjen e destinacionit — ndërprerje), VM-të në punë migrohen live ku është e mundur dhe ndryshe ndalen me rregull, detyrat në vazhdim përfundojnë, puna e re pret dhe VM-të e ndalura humbasin authority-n e tyre — Proximity i rivendos në nisjen tjetër. Asgjë nuk kthehet vetë në fund të mirëmbajtjes.',
    maintenanceExitConfirm: 'Nyja rinis punën dhe Proximity e merr sërish parasysh për placement. VM-të kthehen vetëm kur nisen.',
    maintenanceError: 'Kërkesa e mirëmbajtjes u refuzua',
    maintenancePlanTitle: 'Plani i evakuimit',
    maintenancePlanLoading: 'Po llogaritet plani i evakuimit…',
    maintenancePlanError: 'Plani i evakuimit nuk mund të ngarkohej — drain-i gjithsesi do të migrojë ku mundet dhe do ta ndalë pjesën tjetër.',
    maintenancePlanEmpty: 'Asgjë për të evakuuar në këtë nyje — asnjë shërbim rrjeti aktiv, asnjë instancë App e kërkuar në punë, asnjë VM në punë.',
    maintenancePlanSummary: '{migrate} objekte do të migrojnë (VM, shërbime rrjeti, instanca App), {stop} do të ndalen ose do të qëndrojnë ku janë.',
    maintenancePlanReserve_ok: 'Rezerva e failover-it pas zbrazjes: e paprekur — mbeten {headroom} GiB të nisshëm duke toleruar humbjen e {n} nyjeve.',
    maintenancePlanReserve_eroded: 'Rezerva e failover-it pas zbrazjes: gati e konsumuar — mbeten vetëm {headroom} GiB nga {reserve} GiB të mbajtur të lirë për {n} defekt(e) nyjesh.',
    maintenancePlanReserve_exhausted: 'Rezerva e failover-it pas zbrazjes: E SHTERUAR — mungojnë {headroom} GiB nga {reserve} GiB të nevojshëm për të toleruar {n} defekt(e) nyjesh. Derisa kjo nyjë të jetë jashtë, nisjet e reja të VM-ve do të refuzohen.',
    maintenancePlanReserve_unknown: 'Rezerva e failover-it pas zbrazjes: e pallogaritshme — asnjë nyjë e mbetur s’ka deklaruar memorien.',
    maintenancePlanReserveHugePages: 'Faqe të mëdha prej {size} pas zbrazjes — të lira: {free} nga {capacity}, të kërkuara si rezervë: {reserve}.',
    maintenancePlanActionMigrate: 'migron',
    maintenancePlanActionMigrateWarning: 'migron (rregull soft i shkelur)',
    maintenancePlanActionStop: 'ndalet',
    maintenancePlanActionBlocked: 'e bllokuar',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'shërbim rrjeti',
    maintenancePlanKindApp: 'instancë App',
    maintenancePlanColdMove: 'Zhvendosje në të ftohtë: pod-i ndalet dhe korret këtu dhe rikrijohet në nyjen e destinacionit nga worker-i i saj — ndërprerje deri në pass-in tjetër të worker-it të destinacionit.',
    caFingerprint: 'Fingerprint-i i CA-së së klasterit',
    staleChip: 'i pafreskuar',
    troubleshootTitle: 'Zgjidhja e problemeve të store-it',
    restartStore: 'Rinis shërbimet store',
    restartHint: 'Nëse store-i bën naze, rinis shërbimet e tij. E avancuar — përdore me kujdes.',
    restartQueued: 'Task-u i rinisjes në radhë',
    restartError: 'Shërbimet nuk mund të riniseshin',
    svcActive: 'aktiv',
    svcWanted: 'i dëshiruar, joaktiv',
    svcStopped: 'i ndalur',
    noServices: 'Asnjë shërbim i raportuar'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Inventari GPU i të gjithë klasterit i grupuar sipas modelit — kartat e vëzhguara për nyjë, me regjistrimet e shënuara dhe tag-et e tyre',
    usbTitle: 'Burimet USB',
    usbSubtitle: 'Inventari USB i të gjithë klasterit i grupuar sipas modelit — pajisjet e vëzhguara për nyjë, me regjistrimet e të dy modeleve (për pajisje, për portë) dhe tag-et e tyre',
    markedChip: '{n} të përdorshme nga TVirt',
    orphanChipGpu: '{n} jetime',
    orphanChipUsb: '{n} jetimë',
    colNode: 'Nyja',
    colRegistration: 'Regjistrimi',
    noRegsHint: 'Asnjë regjistrim — pajisja shënohet "e përdorshme nga TVirt" nga dialogu i nyjes (Nyjet › nyja › Cilësimet).',
    colDevice: 'Pajisja',
    colObserved: 'Të vëzhguara',
    colRegs: 'Regjistrimet',
    regsNone: 'asnjë',
    colPci: 'Adresa PCIe',
    colIdentity: 'Identiteti / porta',
    colClasses: 'Klasat (tag)',
    colActions: 'Veprimet',
    manageOnNode: 'Menaxho në nyjën {node} (shënimi jeton në dialogun e nyjes)',
    introTitle: 'Inventari i klasterit i pajisjeve USB dhe PCIe të përdorshme nga TVirt©.',
    introStep1: '1. Nyjet i zbulojnë vetë GPU-të e veta dhe pajisjet USB (censimi në heartbeat).',
    introStep2: '2. Një pajisje shënohet "e përdorshme nga TVirt" nga dialogu i NYJES (Nyjet › nyja › Cilësimet) — shënimi e lidh me vfio dhe e regjistron këtu.',
    introStep3: '3. Këtu u jep regjistrimeve KLASAT e tyre me tag (p.sh. gpu_class=compute): kërkesat e VM-ve do të kërkojnë një klasë, dhe scheduler-i do të zgjedhë një nyjë me një pajisje të lirë të përputhshme.',
    colMode: 'Mënyra',
    colState: 'Gjendja',
    colNotes: 'Shënime',
    colTags: 'Tag',
    modeDevice: 'për pajisje',
    modePort: 'për portë',
    usable: 'e përdorshme',
    orphanGpu: 'jetime',
    orphanUsb: 'jetim',
    hubChip: 'hub',
    orphanPortsTitle: 'Regjistrime për portë pa pajisje të lidhur — rilidh një pajisje ose çshënoji nga nyja',
    gpusEmpty: 'Asnjë GPU e vëzhguar ende në asnjë nyjë',
    usbEmpty: 'Asnjë pajisje USB e vëzhguar ende në asnjë nyjë'
  },

  // Vocabolario condiviso dei form impostazioni (refactoring 2026-07-24): i campi
  // security alimentano la card della pagina Cluster, i campi nodo la pagina
  // node-settings — la pagina /system/settings per cui nacquero è morta.
  settings: {
    passwordMinLength: 'Gjatësia minimale e fjalëkalimit',
    sessionIdle: 'Timeout-i i pasivitetit të sesionit (minuta)',
    lockoutThreshold: 'Bllokim pas tentativash të dështuara',
    lockoutDuration: 'Kohëzgjatja e bllokimit (minuta)',
    keyboardLayout: 'Layout-i i tastierës',
    keyboardLayoutHint: 'p.sh. it, en-us — bosh për default-in QEMU',
    syslogEndpoint: 'Endpoint syslog',
    syslogEndpointHint: 'host:portë — bosh për ta çaktivizuar përcjelljen',
    syslogTls: 'TLS',
    maxQueued: 'Maksimumi i task-eve në radhë',
    concurrency: 'Konkurrenca e worker-it',
    concurrencyHint: 'Zbatohet në fluturim nga worker-i',
    notesTitle: 'Shënime',
    save: 'Ruaj',
    saved: 'Cilësimet u ruajtën',
    saveError: 'Cilësimet nuk mund të ruheshin'
  },
  localSettings: {
    derivedChip: 'i derivuar',
    derivedTip: 'Ky device është PRONË e derivimit të fabric-ut (H2): editori refuzon ta prekë — ndryshoni fabric-un (ose kablimin) dhe riaplikoni, ose merreni prapa më poshtë.',
    takeOwnership: 'Merr pronësinë',
    takeOwnershipTitle: 'Merr pronësinë (take-ownership)',
    takeOwnershipConfirm: '{name} del nga blloku fabric dhe bëhet përsëri një device MANUAL që e qeveris ky editor. Nyja bëhet e shmangur, dhe apply-i i ardhshëm i derivimit do të refuzojë mbi të (manualConflict) derisa ta riemërtoni ose ta hiqni — ose të korrigjoni fabric-un.',
    nodeSettingsTitle: 'Cilësimet e nyjes',
    nodeSettingsSubtitle: 'Ajo që zbaton kjo nyjë — radha e task-eve, konsola, përcjellja e log-eve — plus tag-et e saj dhe shënimet',
    baseTitle: 'Rezervat host (TVirt Proximity)',
    baseSubtitle: 'CPU dhe RAM të rezervuara për sistemin operativ të host-it — input-et e kapacitetit empirik me të cilin Proximity i vendos VM-të',
    baseMemory: 'RAM bazë (MiB)',
    baseMemoryHint: 'Totali i vëzhguar: {total} MiB. E përdorshme për VM-të = totali − baza − RAM e VM-ve të ndezura të vendosura këtu.',
    baseMemoryHintNoTotal: 'E përdorshme për VM-të = totali i vëzhguar − baza − RAM e VM-ve të ndezura të vendosura këtu.',
    baseCpu: 'Core CPU bazë',
    baseCpuHint: 'CPU logjike të vëzhguara: {total}. Përdoren vetëm si peshë ranking-u — overcommit-i i vCPU-ve është normal.',
    baseCpuHintNoTotal: 'Përdoren vetëm si peshë ranking-u — overcommit-i i vCPU-ve është normal.',
    baseHint: 'RAM-i është gate-i i ngurtë i pranimit: një VM që nuk hyn në RAM-in e përdorshëm refuzohet me një gabim që flet qartë. Ngrije bazën në host-et që strehojnë anëtarë të store-it ose demonë Ceph.',
    placementTitle: 'Pozicionimi fizik',
    placementSubtitle: 'Ku ndodhet fizikisht ky server — deklarohet një herë, për çfarëdo që të duhet',
    placementHint: 'Pozicionimi udhëheq hierarkinë CRUSH të çdo klasteri Ceph me një OSD në këtë server: ruajtja e një ndryshimi i ri-rreshton hartat e tyre përmes task-eve (host → rack → … → root). Deklarimet e pjesshme janë të ligjshme — nivelet bosh kolapsojnë. Emrat ndahen në të gjithë hartën: dy serverë në të njëjtin rack deklarojnë të njëjtin emër rack-u.',
    placementNameInvalid: 'Emër DNS-safe (shkronja të vogla, shifra, vija ndarëse)',
    placementEmpty: 'Bosh = i padeklaruar',
    placementLevel: {
      chassis: 'Shasia',
      rack: 'Rack',
      row: 'Rreshti',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Dhoma',
      datacenter: 'Datacenter',
      zone: 'Zona',
      region: 'Rajoni'
    },
    cablingTitle: 'Kabllimi',
    cablingSubtitle: 'Në cilën portë të switch-it është lidhur secila ndërfaqe — deklarimi jeton në nyjë (Annex O.9)',
    cablingHint: 'Një kabllo për NIC, një kabllo për portë në gjithë flotën (API-ja refuzon duke përmendur titullarin). Kabllimi drejt një porte anëtare të një LAGG-u është i ligjshëm — është rasti bond: derivimi i ardhshëm do ta japë si LACP.',
    cablingInterface: 'Ndërfaqja',
    cablingNotCabled: '— e palidhur —',
    cablingNoInterfaces: 'Asnjë ndërfaqe rrjeti e vëzhguar',
    disksTitle: 'Disqet',
    disksSubtitle: 'Pajisje blloku të vëzhguara — një skanim për çdo kalim pajtimi; shëno këtu disqet e përdorshëm si OSD Ceph (N.15: pranueshmëria është eksplicite)',
    colDataDisk: 'Disk të dhënash',
    dataDisksHint: 'Shënimi i një pajisjeje e deklaron të përdorshme si OSD; seriali është pin-i i identitetit të saj — i kopjuar nga hardware-i kur disku e raporton, i farkëtuar (tvirt-…) përndryshe. Dialogu i regjistrimit Ceph ofron vetëm disqet e deklaruar.',
    diskDeclaredSerial: 'i deklaruar',
    diskNotObserved: 'i deklaruar por i pavëzhguar — rilidh pajisjen ose hiqe shenjën',
    noDisks: 'Asnjë pajisje blloku e vëzhguar ende',
    colSerial: 'Seriali',
    colModel: 'Modeli',
    colSize: 'Madhësia (GiB)',
    colDiskType: 'Tipi',
    colInUse: 'Në përdorim',
    colObservedAt: 'Vëzhguar',
    diskInUse: 'në përdorim',
    diskFree: 'i lirë',
    diskMounted: 'i montuar',
    diskPartitions: 'particione',
    passthroughTitle: 'Pajisjet passthrough',
    passthroughSubtitle: 'GPU dhe pajisje USB të vëzhguara — shëno këtu çfarë mund t’u kalojë TVirt VM-ve; shënimi regjistron identitetin e pajisjes (round U1+G1)',
    passthroughHint: 'Shënimi e regjistron pajisjen (një id i qëndrueshëm — target-i i tag-eve dhe i kërkesave të klasës). Një GPU e shënuar e ka TË GJITHË grupin IOMMU të lidhur me vfio-pci në bllok — e lë host-in menjëherë; çshënimi e rilidh driver-in nativ. Për USB ekzistojnë të dy modelet e ratifikuara: për pajisje (vendor+produkt, kudo qoftë e lidhur) dhe për portë fizike (te VM-ja arrin çfarëdo që është futur aty). USB-ja nuk bën bind në shënim — attach-i ndodh në runtime të VM-së.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'E përdorshme nga TVirt',
    colGpu: 'GPU',
    colPciAddress: 'Adresa PCI',
    colDriver: 'Driver',
    colVerdict: 'Verdikti',
    gpuEligible: 'E pranueshme',
    gpuIneligible: 'E papranueshme',
    gpuReason: {
      'no-iommu': 'IOMMU joaktiv në host',
      'group-spans-slots': 'grup IOMMU i paizoluar: shtrihet mbi slote të tjera',
      'multiple-display': 'grup IOMMU i paizoluar: më shumë se një funksion video',
      'foreign-function': 'grup IOMMU i paizoluar: përmban një funksion të huaj'
    },
    vfioNotReady: 'IOMMU nuk është aktiv në këtë host: asnjë GPU nuk është e pranueshme derisa platforma host ta aktivizojë (ISO OEM) — TVirt nuk i prek kurrë kernel args në runtime.',
    vfioMissingKernelArg: 'IOMMU nuk është aktiv në këtë host: firmware-i raporton VT-d/AMD-Vi (tabela ACPI DMAR/IVRS e pranishme) por mungon kernel arg-u — shto intel_iommu=on (Intel) ose hiq amd_iommu=off (AMD) nga command line e kernel-it dhe rinise. TVirt nuk i prek kurrë kernel args në runtime.',
    vfioFirmwareDisabled: 'IOMMU nuk është aktiv në këtë host: VT-d/AMD-Vi është i çaktivizuar në firmware (asnjë tabelë ACPI DMAR/IVRS) ose CPU-ja nuk e mbështet — aktivizoje në setup-in e firmware-it, asnjë kernel arg s’mund ta ndezë. TVirt nuk e prek kurrë host-in në runtime.',
    gpuBindError: 'Bind-i vfio-pci dështoi në {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Firewall mbi bridge të pamenaxhuar',
    firewallBridgesSubtitle: 'Bridge-et e ndërtuar me dorë në këtë nyje, setup-i i të cilëve pranon chain-et firewall të renderuara nga TVirt mbi NIC-et mysafire të lidhura',
    firewallBridgesHint: 'TVirt nuk e prek kurrë bridge-in e huaj — chain-i ankorohet te tap/veth-i, që është gjithmonë i TVirt-it. Lista është një portë pëlqimi: default-deny dhe anti-spoof mund të prishin atë që një setup manual pret, prandaj një NIC me firewall mbi një bridge të pamenaxhuar që NUK është listuar këtu refuzohet me një gabim që flet.',
    firewallBridgesEmpty: 'Asnjë bridge i pamenaxhuar në këtë nyje nuk pranon chain-et firewall të renderuara nga TVirt.',
    firewallBridgeAdd: 'Shto bridge',
    firewallBridgeInvalid: 'Nuk është emër ndërfaqeje Linux (1-15 karaktere, pa slash e pa hapësira)',
    firewallBridgeDuplicate: 'Emri është tashmë në listë',
    colMarkDevice: 'Për pajisje',
    colMarkPort: 'Për portë',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Porta',
    passthroughOrphan: 'jetim — i regjistruar por jo më i detektuar: rilidhe ose çshënoje',
    noGpus: 'Asnjë GPU e vëzhguar ende',
    noUsb: 'Asnjë pajisje USB e vëzhguar ende',
    networkGeneration: 'Gjenerata e rrjetit',
    applied: 'E zbatuar',
    converged: 'në linjë',
    behind: 'prapa — {m} / {n}',
    notConfigured: 'i pakonfiguruar',
    rollbackBody: 'Zbatimi i gjeneratës {gen} dështoi: {error}',
    rolledBackChip: 'rollback i kryer',
    nicsTitle: 'NIC',
    nicsSubtitle:
      'Evidenca e NIC-eve të menaxhuara — regjistrimi ËSHTË deklarimi i menaxhimit: një NIC e regjistruar pa konfigurim nuk preket (clear-if e deklaron shprehimisht të pastër), një pajisje e paregjistruar nuk preket kurrë',
    addNic: 'Regjistro NIC',
    addNicTitle: 'Regjistro NIC (add-nic)',
    delNic: 'Përfundo menaxhimin',
    delNicTitle: 'Përfundo menaxhimin (del-nic)',
    delNicConfirm:
      'Menaxhimi i {name} përfundon: zëri i evidencës dhe konfigurimi i tij fshihen dhe profili TVirt hiqet — pajisja mbetet siç e ka Linux-i.',
    nicName: 'Emri i pajisjes',
    nicMac: 'Adresa MAC e përhershme',
    nicMacHint: 'MAC-u hardware i përhershëm — identiteti i qëndrueshëm i fiksuar nga TVirt Server Installer',
    colObserved: 'E vëzhguar',
    nicObserved: 'e vëzhguar',
    nicNotObserved: 'e pavëzhguar',
    nicMacMismatch: 'MAC divergjent — i vëzhguar {mac}',
    noNics: 'Asnjë NIC e regjistruar — regjistro një pajisje për të filluar ta menaxhosh',
    noManagedDevices: 'Asnjë pajisje e menaxhuar — regjistro më parë një NIC, gjithçka ndërtohet mbi evidencën',
    inventoryTitle: 'Pajisjet e vëzhguara',
    inventorySubtitle: 'Të përditësuara në çdo kalim pajtimi nga worker-i i nyjes — validimi i verifikon emrat e pajisjeve mbi këtë inventar',
    colDevice: 'Pajisja',
    colType: 'Tipi',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Shpejtësia',
    colTopology: 'Topologjia',
    colMtu: 'MTU',
    colAddresses: 'Adresat',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP nuk agregon',
    noInventory: 'Asnjë pajisje e raportuar deri tani',
    interfacesTitle: 'Ndërfaqet',
    interfacesSubtitle:
      'Konfigurimi L3 i NIC-eve të regjistruara dhe i pajisjeve logjike të deklaruara — set-if e zëvendëson bllokun të tërin, edit-if retushon vetitë, clear-if e zbraz (pastrim eksplicit)',
    colConfig: 'Konfigurimi i dëshiruar',
    clean: 'e pastër',
    setIf: 'Modifiko adresimin',
    setIfTitle: 'Modifiko adresimin (set-if)',
    editIf: 'Modifiko vetitë',
    editIfTitle: 'Modifiko vetitë (edit-if)',
    clearIf: 'Zbraz konfigurimin',
    clearIfTitle: 'Zbraz konfigurimin (clear-if)',
    clearIfConfirm: 'Konfigurimi i ndërfaqes zbrazet. Një ndërfaqe e pastër është parakushti për ta nënshtruar si anëtare bond-i/bridge-i ose parent i një VLAN-i.',
    ip4Mode: 'Mënyra IPv4',
    ip6Mode: 'Mënyra IPv6',
    modeUnconfigured: 'E pakonfiguruar',
    modeStatic: 'Statike',
    modeDhcp: 'DHCP',
    ip4Addresses: 'Adresat IPv4',
    ip6Addresses: 'Adresat IPv6',
    addressesHint: 'CIDR, të ndara me presje',
    gw4: 'Gateway IPv4',
    gw6: 'Gateway IPv6',
    dns: 'Serverët DNS',
    dnsHint: 'të ndarë me presje — bosh e zeron DNS-in (set-if e zëvendëson bllokun)',
    routes4: 'Rrugë statike IPv4',
    routes6: 'Rrugë statike IPv6',
    routeTo: 'Destinacioni (CIDR)',
    routeVia: 'Përmes',
    addRoute: 'Shto rrugë',
    routesChip: 'rrugë',
    mtu: 'MTU',
    mtuHint: 'bosh = default-i i driver-it',
    vlansTitle: 'VLAN',
    addVlan: 'Shto VLAN',
    addVlanTitle: 'Shto VLAN (add-vlan)',
    delVlanTitle: 'Fshi VLAN (del-vlan)',
    vlanParent: 'Ndërfaqja parent',
    vlanId: 'ID e VLAN-it',
    vlanPreview: 'Emri i pajisjes',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Asnjë VLAN e deklaruar',
    bondsTitle: 'Bond',
    addBond: 'Shto bond',
    addBondTitle: 'Shto bond (add-bond)',
    editBondTitle: 'Modifiko bond-in',
    editBond: 'Ruaj bond-in',
    delBondTitle: 'Fshi bond-in (del-bond)',
    bondName: 'Emri i bond-it',
    members: 'Anëtarët',
    membersHint: 'anëtarët duhet të jenë ndërfaqe të pastra (pa konfigurim L3)',
    bondMode: 'Mënyra',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Anëtari primar',
    rate: 'Rate LACP',
    hash: 'Politika e hash-it në transmetim',
    colMembers: 'Anëtarët',
    colMode: 'Mënyra',
    noBonds: 'Asnjë bond i deklaruar',
    bridgesTitle: 'Bridge',
    addBridge: 'Shto bridge',
    addBridgeTitle: 'Shto bridge (add-bridge)',
    editBridgeTitle: 'Modifiko bridge-in',
    editBridge: 'Ruaj bridge-in',
    delBridgeTitle: 'Fshi bridge-in (del-bridge)',
    bridgeName: 'Emri i bridge-it',
    stp: 'STP',
    stpOn: 'STP aktiv',
    stpOff: 'STP i fikur',
    colStp: 'STP',
    noBridges: 'Asnjë bridge i deklaruar',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Cakto hostname',
    setHostnameTitle: 'Cakto hostname (set-hostname)',
    hostnameHint: 'Vetëm identitet OS — emri i nyjes në klaster nuk preket',
    notSet: 'i pacaktuar',
    staticHostsTitle: 'Zëra host statikë',
    addStaticHost: 'Shto zë',
    addStaticHostTitle: 'Shto zë host statik',
    delStaticHostTitle: 'Fshi zërin host statik',
    hostIp: 'Adresa IP',
    hostNames: 'Emrat',
    hostNamesHint: 'të ndarë me presje ose hapësirë',
    colIp: 'IP',
    colNames: 'Emrat',
    noStaticHosts: 'Asnjë zë host statik',
    delConfirm: 'Heqja e {name} nga dokumenti i dëshiruar — worker-i i nyjes konvergon me një checkpoint të NetworkManager dhe rollback automatik.',
    remove: 'Hiq',
    opError: 'Operacioni i rrjetit u refuzua'
  }
}
